module.exports = __webpack_public_path__ + "static/media/roll-dice-40.a96ea1b1.png";